import React from 'react';
import { LoadingSpinner } from 'edenred-ui';
import { FormProvider } from 'react-hook-form';

import { ITopup } from '@epi-models/pages/TransferPage';
import { useTopup, useTopupFormContext } from '@epi-pages/TransferPage/hooks';

import { TopupUnavailable } from './TopupUnavailable';
import { TopupForm } from './TopupForm';

export const Topup = ({ updateFooter }: ITopup) => {
  const { hasLoadableBenefit, isLoading, activeBenefits } = useTopup();
  const { form } = useTopupFormContext();

  if (isLoading) return <LoadingSpinner />;

  if (hasLoadableBenefit)
    return (
      <FormProvider {...form}>
        <TopupForm
          updateFooter={updateFooter}
          form={form}
          loadableBenefits={activeBenefits}
        />
      </FormProvider>
    );

  return <TopupUnavailable />;
};
